export { default } from './InlineLabelWrapper';
